import { FormCard } from '@portal_components/components/FormCard';
import { FormRadioButtonGroup } from '@portal_components/components/FormRadioButtonGroup';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { MeterPointDetails } from '../../types';

interface SiteContactDetailsTabProps {
  readonly: boolean;
}

export const SiteContactDetailsTab = ({ readonly }: SiteContactDetailsTabProps) => {
  return (
    <FormCard>
      <FormTextInput<MeterPointDetails> title="Site Contact Title" name="contact.siteContactTitle" mandatory readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Site Contact First Name" name="contact.siteContactFirstname" readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Site Contact Surname" name="contact.siteContactSurname" readonly={readonly} mandatory />
      <FormTextInput<MeterPointDetails> title="Site Contact Number" name="contact.siteContactNumber" readonly={readonly} mandatory />
      <FormTextInput<MeterPointDetails> title="Site Contact Extension" name="contact.siteContactExtensionNumber" readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Site Contact Email" name="contact.emailAddress" readonly={readonly} />
      <FormRadioButtonGroup<MeterPointDetails>
        title="Preferred Contact Method"
        name="contact.preferredContactMethod"
        buttons={[
          { title: 'Phone', value: 'Phone' },
          { title: 'Email', value: 'Email' }
        ]}
      />
      <FormTextInput<MeterPointDetails> title="Site Contact Mobile Number" name="contact.mobileNumber" readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Site Contact Fax Number" name="contact.faxNumber" readonly={readonly} />
    </FormCard>
  );
};
